import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { scrollToTop, navigateToSection } from "./utils/Constants.js";
import { menu_icon, exit_icon } from "../assets/svgs/svg-icons.js";
import { Link } from "react-router-dom";
import "../styles/components/navbar.scss";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const navbarRef = useRef(null);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 15);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const handleNavClick = (sectionId) => {
    setMenuOpen(false);
    if (location.pathname !== "/") {
      localStorage.setItem("scrollTarget", sectionId);
      navigate("/");
    } else {
      navigateToSection(sectionId);
    }
  };

  return (
    <div className={`navbar ${menuOpen ? "menu-open" : ""}`}>
      <div className="container">
        <Link to="/" className="heading">
          Joyce Kadibu
        </Link>
        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <span>{menu_icon}</span> : <span>{exit_icon}</span>}
        </div>
        <div className={`nav-drawer ${menuOpen ? "open" : ""}`}>
          <a
            aria-label="about me"
            href="#about-me"
            onClick={() => {
              handleNavClick("about-me");
              setMenuOpen(false);
              navigateToSection();
            }}
          >
            About Me
          </a>
          <a
            aria-label="awards"
            href="#awards"
            onClick={() => {
              handleNavClick("awards");
              setMenuOpen(false);
              navigateToSection();
            }}
          >
            Awards
          </a>
          <a
            aria-label="skills"
            href="#skills"
            onClick={() => {
              handleNavClick("skills");
              setMenuOpen(false);
              navigateToSection();
            }}
          >
            Skills
          </a>
          <a
            aria-label="projects"
            href="#projects"
            onClick={() => {
              handleNavClick("projects");
              setMenuOpen(false);
              navigateToSection();
            }}
          >
            Projects
          </a>
          <a
            aria-label="gallery"
            href="#gallery"
            onClick={() => {
              handleNavClick("gallery");
              setMenuOpen(false);
              navigateToSection();
            }}
          >
            Gallery
          </a>
          <a
            aria-label="contact"
            href="#contact"
            onClick={() => {
              handleNavClick("contact");
              setMenuOpen(false);
              navigateToSection();
            }}
          >
            Contact
          </a>
        </div>
      </div>
    </div>
  );
}
